/* ============================================
   SILVIQ — Scroll Reveal JS
   
   HOW TO INSTALL:
   1. Go to Shopify Admin → Themes → Edit code
   2. In the Assets folder, add a new asset: "silviq-reveal.js"
   3. Paste this file
   4. Open layout/theme.liquid
   5. Add this line just before </body>:
      <script src="{{ 'silviq-reveal.js' | asset_url }}" defer></script>
   6. Save
   
   USAGE:
   Add class="silviq-reveal" to any element for fade-up on scroll.
   Add class="silviq-reveal-stagger" to a parent to stagger children.
   ============================================ */
 
(function () {
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
 
  function init() {
    document.querySelectorAll('.silviq-reveal, .silviq-reveal-stagger').forEach(function (el) {
      observer.observe(el);
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
 